import type { StatusTone } from "@/components/ui";

export function formatLabel(value: string): string {
  return value.replaceAll("_", " ");
}

export function moneyTone(status: string): StatusTone {
  switch (status) {
    case "succeeded":
    case "approved":
    case "executed":
    case "paid":
    case "settled":
    case "reconciled":
    case "resolved":
    case "active":
      return "success";
    case "pending":
    case "initiated":
    case "requested":
    case "under_review":
    case "pending_review":
    case "processing":
    case "eligible":
    case "scheduled":
    case "draft":
    case "detected":
    case "investigating":
    case "awaiting_information":
    case "delayed":
      return "warning";
    case "failed":
    case "rejected":
    case "disputed":
    case "held":
    case "unmatched":
    case "requires_intervention":
    case "escalated":
    case "critical":
    case "urgent":
      return "danger";
    default:
      return "neutral";
  }
}

const moneyFormats = new Map<string, Intl.NumberFormat>();

/**
 * Display only. `amount` is the ledger's decimal peso value as the record DTOs
 * carry it (the database column is numeric); never add or compare these as
 * floats. The Overview tab works in integer centavos instead.
 */
export function formatMoney(amount: number, currency: string): string {
  let f = moneyFormats.get(currency);
  if (!f) {
    try {
      f = new Intl.NumberFormat("en-PH", { style: "currency", currency });
    } catch {
      return `${amount} ${currency}`;
    }
    moneyFormats.set(currency, f);
  }
  return f.format(amount);
}
